(() => {
  document.addEventListener('click', (event) => {
    const tab = event.target.closest('[data-hs-tab]');
    if (tab) {
      const section = tab.closest('[data-hs-section]');
      section.querySelectorAll('[data-hs-tab]').forEach(button => button.setAttribute('aria-selected', String(button === tab)));
      section.querySelectorAll('[role="tabpanel"]').forEach(panel => { panel.hidden = panel.id !== tab.getAttribute('aria-controls'); });
    }
    const arrow = event.target.closest('[data-hs-scroll]');
    if (arrow) {
      const track = arrow.closest('.hs-collection-panel').querySelector('.hs-products');
      track.scrollBy({left: Number(arrow.dataset.hsScroll) * track.clientWidth, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
    }
  });
  document.addEventListener('keydown', (event) => {
    if (!event.target.matches('[data-hs-tab]') || !['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
    event.preventDefault();
    const tabs = [...event.target.parentElement.querySelectorAll('[data-hs-tab]')];
    const index = tabs.indexOf(event.target);
    const next = event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length - 1 : (index + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
    tabs[next].focus(); tabs[next].click();
  });
})();
